<script setup lang="ts"></script>

<template>
  <div class="page">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.page {
  height: 100%;
  background-color: $primary-black;
}
</style>
